import { render, staticRenderFns } from "./getCodeInfo.vue?vue&type=template&id=6864c310&scoped=true"
import script from "./getCodeInfo.vue?vue&type=script&lang=js"
export * from "./getCodeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864c310",
  null
  
)

export default component.exports